// extracted by mini-css-extract-plugin
module.exports = {"Page-layout":"page-layout_Page-layout__ukhvk","Page-layout--single-column":"page-layout_Page-layout--single-column__W_Ovs"};